import { ReactNode, createContext, useContext, useState } from "react";

const NavbarCommonSpace = createContext<
  [
    ReactNode | ReactNode[] | null,
    (lang: ReactNode | ReactNode[] | null) => void
  ]
>(["english", (_) => {}]);

export function NavbarCommonSpaceProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const val = useState<ReactNode | ReactNode[]>(null);

  return (
    <NavbarCommonSpace.Provider value={val}>
      {children}
    </NavbarCommonSpace.Provider>
  );
}

export function useStuffToRender() {
  return useContext(NavbarCommonSpace)[0];
}

export function useSetStuffToRenderOnNavbar() {
  return useContext(NavbarCommonSpace)[1];
}
